import type { ScheduleGrid } from "../model/types";

import { DAY_KEYS, HOUR_KEYS } from "../model/types";
import { createEmptyGrid } from "./scheduleHeatmap";

export const scheduleGridToValues = (grid: ScheduleGrid): (null | number)[][] =>
  HOUR_KEYS.map((hour) => DAY_KEYS.map((day) => grid[day][hour]));

export const scheduleValuesToGrid = (values: (null | number)[][]): ScheduleGrid => {
  const grid = createEmptyGrid();

  HOUR_KEYS.forEach((hour, rowIndex) => {
    DAY_KEYS.forEach((day, columnIndex) => {
      const row = values[rowIndex];
      const value = row?.[columnIndex];
      grid[day][hour] = value === undefined ? null : value;
    });
  });

  return grid;
};
